module.exports = __webpack_public_path__ + "img/logo-light.6c6c7c94.svg";